export const environment = {
    production: false,
    apiBaseUrl: 'https://api.ikenowmx.com',
    apiGoogleMapsKey: 'AIzaSyDRhQvyrCwQFiOCsqO4uOiqiC0AVu6Sn2U',
    trackingBaseUrl: 'https://alb-prod-yaab.ikeasistencia.com/api/v1/map/assistance',
    appVersion: '1.0.0',
};
